// extracted by mini-css-extract-plugin
module.exports = {"container":"uploadArea_container__pknVH","upload":"uploadArea_upload__2dyiQ","icon":"uploadArea_icon__2Hwav"};